import React, { useEffect, useState } from "react";

const url = process.env.REACT_APP_BACKEND_URL;

export const AuthContext = React.createContext({
  userData: [],
  isLoggedIn: false,
  isAdmin: false,
  token: null,
  isLoading: false,
  error: undefined,
  login: (userData) => {},
  logout: () => {},
});

const AuthContextProvider = (props) => {
  const [userData, setUserData] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState();
  const [isSuccess, setIsSuccess] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState();

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("userData"));
    if (
      storedData &&
      storedData.token &&
      new Date(storedData.expiresIn) > new Date()
    ) {
      setUserData(storedData.userData);
      setToken(storedData.token);
      if (storedData.role === "admin") {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
      setIsLoggedIn(true);
    } else {
      localStorage.removeItem("userData");
    }
  }, []);

  const login = async (userData) => {
    setIsLoading(true);
    setError(undefined);
    const response = await fetch(`${url}/endusers/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });
    const responseData = await response.json();
    setIsLoading(false);
    if (responseData.message) {
      setError(responseData.message);
      return;
    }
    setIsLoggedIn(true);
    setUserData(responseData);
    setIsAdmin(responseData.isAdmin);
    setToken(responseData.token);
    const expirationDate = new Date(new Date().getTime() + 1000 * 60 * 60);
    localStorage.setItem(
      "userData",
      JSON.stringify({
        token: responseData.token,
        expiresIn: expirationDate,
        userData: responseData,
        role: responseData.isAdmin === true ? "admin" : "user",
      })
    );
  };

  const register = async (userData) => {
    setIsLoading(true);
    setError(undefined);
    const response = await fetch(`${url}/endusers/register/new-account`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });
    const responseData = await response.json();
    setIsLoading(false);
    if (responseData.message) {
      setError(responseData.message);
      return;
    }
    if (responseData.success) {
      setIsSuccess(responseData.success);
    }
    setTimeout(() => {
      setIsSuccess(undefined);
    }, 3000);
  };

  const logout = () => {
    setIsLoggedIn(false);
    setToken(undefined);
    localStorage.removeItem("userData");
  };

  return (
    <AuthContext.Provider
      value={{
        userData: userData,
        isLoggedIn: isLoggedIn,
        token: token,
        isAdmin: isAdmin,
        login: login,
        logout: logout,
        error: error,
        isLoading: isLoading,
        register: register,
        isSuccess: isSuccess,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
